import React, { Component } from 'react'
import GlobalSearchUi from '../../presentational/Includes/GlobalSearch.component'
import { STRING, QUERY_PARAMS } from '../../../utils/Constant'
import Routes from '../../../Layout/Routes'

class GlobalSearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableMaxValue: 3,
            handledKey: '',
            Btn2Val: STRING.SECTORS,
            btnDropDown: false,
            globalSearchData: ''
        }
    }

    componentDidMount() {
        this.setState({
            globalSearchData: ''
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.globalSearchData !== this.props.globalSearchData) {
            this.setState({
                globalSearchData: this.props.globalSearchData
            })
        }
    }

    render() {
        return (
            <GlobalSearchUi
                globalPageHandler={this.globalPageHandler.bind(this)}
                globalSearchData={this.state.globalSearchData}
                tableMaxValue={this.state.tableMaxValue}
                searchMoreHandler={this.searchMoreHandler.bind(this)}
                handledKey={this.state.handledKey}
                searchTabHandler={this.searchTabHandler.bind(this)}
                getBtnValue={this.getBtnValue.bind(this)}
                Btn2Val={this.state.Btn2Val}
                btnDropDown={this.state.btnDropDown}
            />
        )
    }

    getBtnValue(e, type) {
        e.stopPropagation()
        this.setState({ btnDropDown: !this.state.btnDropDown })
    }

    searchTabHandler(param, tab) {
        if (param === QUERY_PARAMS.SECTOR || param === QUERY_PARAMS.INDUSTRY || param === QUERY_PARAMS.SUB_INDUSTRY) {
            this.setState({
                Btn2Val: tab
            })
        }

        this.setState({
            selectedTab: tab,
            selectedTabToSend: param,
            btnDropDown: false,
        }, () => {
            this.props.history.push({
                pathname: Routes.SEARCH,
                state: {
                    selectedTab: this.state.selectedTab,
                    selectedTabToSend: this.state.selectedTabToSend,
                    pageType: 'globalSearch'
                }
            })
            this.globalPageHandler('', false)
        })
    }


    globalPageHandler(e, val) {
        this.props.globalPageHandler(e, val)
    }

    searchMoreHandler(e, type, key) {
        if (type === 'more') {
            this.setState({
                tableMaxValue: this.props.globalSearchData[key].length
            })
        } else if (type === 'less') {
            this.setState({
                tableMaxValue: 3
            })
        }
        this.setState({
            handledKey: key
        })
    }
}

export default GlobalSearchPage;